import React, { useState, useEffect } from "react";
import {
  Grid,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider as MuiDivider,
} from "@mui/material";
import {
  AddBoxOutlined as AddIcon,
  Close as CloseIcon,
  Delete as DeleteIcon,
  Save as SaveIcon,
} from "@mui/icons-material";
import { spacing } from "@mui/system";
import styled from "@emotion/styled";
import { toast } from "react-toastify";

import {
  renderColumn,
  getSubFormContrlsObj,
  getNextSerial,
  saveSubFormRow,
  deleteSubFormRow,
} from "src/utils/amUtils";
//import AMMaterialTable from "src/pages/components/AMMatrialTable";
import AMFooterTable from "src/pages/components/AMFooterTable";
import FormInput from "src/pages/components/AMFormInput";
import logger from "src/services/logService";
import * as Enums from "src/utils/enums";
import useForm from "src/hooks/useForm";

function TestFooter({ formControls, tableData, title, setTableData }) {
  const [columns, setColumns] = useState([]);

  //initColumns
  useEffect(() => {
    const initColumns = () => {
      const columns = [];
      columns.push(renderColumn("id", {}, { hidden: true }));
      columns.push(renderColumn("serial", formControls.serial));
      columns.push(renderColumn("lineDesc", formControls.lineDesc));
      columns.push(renderColumn("lineTransDate", formControls.lineTransDate));
      columns.push(renderColumn("lineIsActive", formControls.lineIsActive));
      columns.push(
        renderColumn("lineCountryId", formControls.lineCountryId, {
          hidden: true,
        })
      );
      columns.push(
        renderColumn("lineCountryName", formControls.lineCountryName)
      );

      return columns;
    };

    setColumns(initColumns());
  }, [formControls]);

  //#region Add/Edit Form

  const {
    state: subFormState,
    errors: subFormErrors,
    handleSetState: setSubFormState,
    handleSelectedIndexChange: handleSelectedIndexChange,
    renderFormInput,
    vaLidateFormData: validateSubFormData,
  } = useForm(
    "",
    "",
    null,
    null,
    null,
    null,
    true,
    getSubFormContrlsObj(formControls, [
      "lineDesc",
      "lineTransDate",
      "lineIsActive",
      "lineCountryId",
    ]) //you have to filter because of validation schema
  );

  const gridItemProps = {
    sm: 4,
    xs: 12,
    style: { paddingBottom: 5, paddingTop: 5 },
  };

  const handleCountrySelectedIndexChanged = (
    event,
    value,
    reason,
    fieldName
  ) => {
    try {
      //No Need for ...subFormState because it's handleed inside useFormHook
      //setSubFormState({ ...subFormState, lineCountryName: value.textField });
      setSubFormState({ lineCountryName: value.textField });
      handleSelectedIndexChange(event, value, reason, fieldName);
    } catch (error) {
      throw error;
    }
  };

  const editForm = (
    <Grid container spacing={4}>
      {renderFormInput(
        "serial",
        Enums.ControlType.TextField,
        {
          disabled: true,
          style: { maxWidth: 100 },
        },
        gridItemProps
      )}
      {renderFormInput(
        "lineDesc",
        Enums.ControlType.TextField,
        {},
        gridItemProps
      )}
      {renderFormInput(
        "lineTransDate",
        Enums.ControlType.DatePicker,
        {},
        gridItemProps
      )}
      {renderFormInput(
        "lineIsActive",
        Enums.ControlType.CheckBox,
        {},
        gridItemProps
      )}
      <FormInput
        type={Enums.ControlType.AutoSearch}
        name={"lineCountryId"}
        control={formControls["lineCountryId"]}
        onChange={handleCountrySelectedIndexChanged}
        value={subFormState["lineCountryId"] || ""}
        errorMsg={subFormErrors["lineCountryId"]}
        gridItemProps={gridItemProps}
      />
    </Grid>
  );
  //#endregion

  return (
    <>
      {columns.length > 0 && (
        <AMFooterTable
          title={title}
          columns={columns}
          tableData={tableData}
          setTableData={setTableData}
          subFormState={subFormState}
          setSubFormState={setSubFormState}
          subFormErrors={subFormErrors}
          validateSubFormData={validateSubFormData}
          editForm={editForm}
        />
      )}
    </>
  );
}
export default TestFooter;
